import { East } from "@mui/icons-material";
import React from "react";
import LinkElement from "./LinkElement";
import RouteElement from "./RouteElement";
import TextElement from "./TextElement";

const Element = (props) => {
  switch (props.element_type) {
    case "Link":
      return <LinkElement {...props} />;
    case "Route":
      // FIXME: Hardcoded switch to shop route, to remove when we onboard more routes
      return props?.hidden ? null : (
        <RouteElement
          {...props}
          endIcon={props?.disabled ? null : <East />}
          disabled={props?.disabled}
          title={props?.disabled ? "Sorry, We're Closed" : props.title}
          mainButton
        />
      );
    case "Text":
      return <TextElement description={props.long_description} {...props} />;
    default:
      return null;
  }
};

export default Element;
